import { errorMessage, warningMessage } from '@/utils/toast';

export const MIN_CLUSTER_FROM_TASK_KEYWORDS = 50;

export type ClusterFromTaskBody = {
  task_id: string;
  domain_slug: string;
};

export type ClusterFromTaskResult = {
  msg?: string;
  data?: { task_id?: string };
};

type ClusterFromTaskMutate = (
  body: ClusterFromTaskBody
) => { unwrap: () => Promise<ClusterFromTaskResult> };

export const hasEnoughKeywordsForCluster = (keywordCount = 0) =>
  keywordCount >= MIN_CLUSTER_FROM_TASK_KEYWORDS;

export const isClusterFromTaskDisabled = ({
  isClustering,
  taskId,
  keywordCount,
  isTaskReady = true
}: {
  isClustering?: boolean;
  taskId?: string;
  keywordCount?: number;
  isTaskReady?: boolean;
}) =>
  Boolean(isClustering) ||
  !taskId ||
  !hasEnoughKeywordsForCluster(keywordCount) ||
  !isTaskReady;

export const submitClusterFromTask = async ({
  mutate,
  taskId,
  domainSlug,
  domain,
  navigate,
  hasEnoughKeywords
}: {
  mutate: ClusterFromTaskMutate;
  taskId?: string;
  domainSlug?: string;
  domain?: string;
  navigate: (path: string) => void;
  hasEnoughKeywords: boolean;
}) => {
  if (!taskId || !domainSlug || !domain || !hasEnoughKeywords) return false;

  try {
    const response = await mutate({
      task_id: taskId,
      domain_slug: domainSlug
    }).unwrap();
    const clusterTaskId = response?.data?.task_id;
    if (!clusterTaskId) {
      errorMessage(response?.msg || 'در ثبت درخواست کلاسترینگ خطایی رخ داد.');
      return false;
    }
    if (response.msg?.includes('2000')) {
      warningMessage(response.msg);
    }
    navigate(
      `/keyword-research/clustering/${domainSlug}/${domain}/${clusterTaskId}`
    );
    return true;
  } catch (err) {
    console.log('Error on cluster from task:', err);
    const apiMsg = (err as { data?: { msg?: string } })?.data?.msg;
    errorMessage(apiMsg || 'در ثبت درخواست کلاسترینگ خطایی رخ داد.');
    return false;
  }
};
